import React from "react";

import Game from "./pages/Game";

const App = () => {
  return <Game />;
};

export default App;
